import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { WizardStepContext } from '.'
import { InformationalPill } from '@contrast-security-inc/design-system-badges'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Card } from '@contrast-security-inc/design-system-surfaces'
import { Text } from '@contrast-security-inc/design-system-typography'
import { StepContent } from './agent-wizard-steps'

export const RecommendedOption = ({ Content }) => {
  const intl = useIntl()

  return (
    <Stack>
      <StepContent step={{ Content }} />
      <InformationalPill
        text={intl.formatMessage({ id: 'badge_recommended' })}
      />
    </Stack>
  )
}

export const cardLargeCss = css`
  display: flex;
  flex: 1 1 0px;
  min-width: calc(50% - 6px);
  max-width: calc(50% - 6px);
  height: 164px;
`
export const cardSmallCss = css`
  display: flex;
  flex: 1 1 0px;
  align-items: center;
  min-width: calc(33% - 16px);
  max-width: 50%;
  height: 32px;
  padding: 24px;
  overflow-y: hidden;
`
const iconPaddingCss = css`
  padding-left: 16px;
  padding-right: 16px;
`
// uses the wizard step branches to select different step branches
export const StepSelector = ({
  branchKey,
  options,
  Component = Card,
  size = 'small',
  detailMsg,
  postDetailMsg
}) => {
  const ctx = React.useContext(WizardStepContext)
  const branchOption = ctx.branches[branchKey]
  const intl = useIntl()

  return (
    <>
      <Text font="body" as="div">
        {detailMsg &&
          intl.formatMessage(
            { id: detailMsg?.message || detailMsg },
            detailMsg?.values
          )}
      </Text>
      <Stack
        className={css`
          padding: 24px 0px;
          flex-wrap: wrap;
        `}
      >
        {options.map((option, index) => (
          <Component
            data-testid={`step-selector-${branchKey}-${option.value}`}
            key={index}
            className={size === 'large' ? cardLargeCss : cardSmallCss}
            {...(option.props || {})}
            isSelected={branchOption === option.value}
            onSelect={() => {
              ctx.setBranch(branchKey, option.value)
            }}
          >
            {option.icon}
            <Text
              font="body"
              className={option.icon ? iconPaddingCss : undefined}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              <StepContent step={option} />
            </Text>
            {option.secondIcon ? option.secondIcon : null}
            {option.secondContent && (
              <Text
                font="body"
                className={option.secondIcon ? iconPaddingCss : undefined}
              >
                <StepContent step={option} isSecondary={true} />
              </Text>
            )}
          </Component>
        ))}
      </Stack>
      <Text font="body" as="div">
        {postDetailMsg &&
          intl.formatMessage(
            { id: postDetailMsg?.message || postDetailMsg },
            postDetailMsg?.values
          )}
      </Text>
    </>
  )
}
